<template>
  <div class="webinar-insert-form document-webinar">
    <div class="row">
      <div class="col-md-12">
        <!-- 1. Satır: Webinar türü, Tarih, Saat dilimi -->
        <div class="row mb-3">
          <div class="col-md-4">
            <h5 class="uk-text-bold mb-2">{{ $t('general.webinar_type') }}</h5>
            <multiselect :allow-empty="false"
                         :options="webinarTypes"
                         :placeholder="$t('general.select_webinar_type')"
                         :searchable="true"
                         :value="integrationType"
                         deselectLabel=""
                         label="name"
                         :selectLabel="$t('general.select')"
                         track-by="id"
                         @input="handleIntegrationTypeChange"
            />
          </div>

          <div class="col-md-4">
            <h5 class="uk-text-bold mb-2">{{ $t('general.date') }}*</h5>
            <VueCtkDateTimePicker :format="'YYYY-MM-DD HH:mm'"
                                  :no-button-now="true"
                                  :value="startsAt"
                                  @input="$emit('update:startsAt', $event)"
            />
          </div>

          <div v-if="selectedWebinarType !== null && selectedWebinarType.key !== 'teams'" class="col-md-4">
            <h5 class="uk-text-bold mb-2">{{ $t('general.timezone') }}</h5>
            <select id="webinar_timezone" class="form-control" name="webinar_timezone">
              <option>Europe/Istanbul</option>
            </select>
          </div>
        </div>

        <!-- 2. Satır: Eğitmen adı, Güvenlik -->
        <div class="row mb-3">
          <div class="col-md-4">
            <h5 class="uk-text-bold mb-2">{{ $t('general.instructor_name') }}</h5>
            <input id="webinar_instructor_name"
                   :value="instructorName"
                   class="form-control"
                   maxlength="255"
                   name="webinar_instructor_name"
                   type="text"
                   @input="$emit('update:instructorName', $event.target.value)"
            />
          </div>

          <div v-if="selectedWebinarType !== null && selectedWebinarType.key !== 'teams'" class="col-md-4">
            <h5 class="uk-text-bold mb-2">{{ $t('general.security') }}</h5>
            <input id="webinar_security"
                   :value="password"
                   class="form-control"
                   name="webinar_security"
                   type="text"
                   @input="$emit('update:password', $event.target.value)"
            />
            <small>{{ $t('general.link_owner_can_join_meeting') }}</small>
          </div>
        </div>

        <div v-if="selectedWebinarType !== null && selectedWebinarType.key !== 'teams'" class="row mb-3">
          <div class="col-md-12">
            <p>
              <input id="webinar_option_3"
                     :checked="isAutoRecordingEnabled"
                     class="mr-1"
                     name="webinar_option_3"
                     type="checkbox"
                     @change="$emit('update:isAutoRecordingEnabled', $event.target.checked)"
              >
              <label for="webinar_option_3"> {{ $t('general.save_meeting_to_computer') }} </label>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "DocumentWebinar",
  components: {
    Multiselect,
    VueCtkDateTimePicker
  },
  props: {
    integrationType: {
      type: Object,
      default: null
    },
    webinarTypes: {
      type: Array,
      default: () => []
    },
    startsAt: {
      type: String,
      default: null
    },
    password: {
      type: String,
      default: null
    },
    isAutoRecordingEnabled: {
      type: Boolean,
      default: false
    },
    integrationId: {
      type: Number,
      default: null
    },
    instructorName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedWebinarType: null
    };
  },
  methods: {
    handleIntegrationTypeChange(event) {
      this.selectedWebinarType = event;
      this.$emit('update:integrationType', event);
      this.$emit('update:integrationId', event ? event.id : null);
    }
  },
  watch: {
    integrationType: {
      immediate: true,
      handler(value) {
        this.selectedWebinarType = value;
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.document-webinar .form-control,
.document-webinar select,
.document-webinar input[type="text"] {
  height: 43px;
}

.document-webinar .multiselect,
.document-webinar .multiselect__tags {
  min-height: 43px;
}

.document-webinar .multiselect__tags {
  padding-top: 8px;
}

.document-webinar :deep(.field-input) {
  height: 43px !important;
}
</style>
